import { Button } from "@shared/components";
import React from "react";
import { useIntl } from "react-intl";

interface IProps {
  url: URL | null;
}

export const IFrameError = ({ url }: IProps) => {
  const intl = useIntl();

  if (!url) {
    return null;
  }

  const handleOpenGame = () => {
    window.open(url);
  };

  return (
    <>
      <div>
        1.{" "}
        {intl.formatMessage({
          id: "boilerplate.components.GameMessage.StepOne",
        })}
      </div>
      <code className="games-code">chrome://settings/cookies</code>
      <div>
        2.{" "}
        {intl.formatMessage({
          id: "boilerplate.components.GameMessage.StepTwo",
        })}
      </div>
      <div className="games-title-wrapper">
        {intl.formatMessage({
          id: "boilerplate.components.GameMessage.TitleIframeErrorTwo",
        })}
      </div>
      <Button tagName="button" variant="primary" onClick={handleOpenGame}>
        {intl.formatMessage({
          id: "boilerplate.components.GameMessage.Button.OpenGame",
        })}
      </Button>
    </>
  );
};
